import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import Portfolio from "@/pages/Portfolio";
import Inbox from "@/pages/Inbox";

function App() {
  return (
    <div className="App noise-overlay">
      <LanguageProvider>
        <ReactLenis root options={{ lerp: 0.08, duration: 1.4 }}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Portfolio />} />
              <Route path="/inbox" element={<Inbox />} />
            </Routes>
          </BrowserRouter>
        </ReactLenis>
      </LanguageProvider>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: { background: "#1A1A1C", color: "#F5F5F0", border: "1px solid #2A2A2E", borderRadius: 0 },
        }}
      />
    </div>
  );
}

export default App;
